import { render, staticRenderFns } from "./QrcodeRender.vue?vue&type=template&id=2be44f5e&"
import script from "./QrcodeRender.vue?vue&type=script&lang=js&"
export * from "./QrcodeRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports